import { Subscription } from 'rxjs';
import { LineupService } from '../../../services/lineup.service';
import { Lineup } from '../../../interfaces/lineup';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'lineup-details-cycles',
	templateUrl: './lineup-details-cycles.component.html',
	styleUrls: ['./lineup-details-cycles.component.scss']
})

export class LineupDetailsCyclesComponent implements OnInit, OnDestroy {
	@Input() lineup: Lineup;
	@Input() form: NgForm;

	subscriptions = new Subscription();

	constructor(
		public lineupService: LineupService
	) {
	}

	ngOnInit() {
		this.subscriptions.add(this.lineupService.liveItemsSubject.subscribe(liveItems => {
			if (liveItems > this.lineupService.maxLiveCount) {
				this.form.control.setErrors({ required: true });
			} else {
				this.form.control.setErrors(null);
			}
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	onLineupUpdate(lineup: Lineup) {
		this.lineupService.checkLiveCount(lineup);
	}
}
